import { useState } from "react";

function MenuItem(props) {
  const renderSpice = (spiceLevel) => {
    let spice = [];
    for (let i = 0; i < spiceLevel; i++) {
      spice.push(<span key={i}>&#x1F336;</span>);
    }
    return spice;
  }

  const renderItems = () => {
    return props.dishes.map((dish, index, array) => {
      if (!dish.options && dish.priceGbp) {
        return (
          <div className="c-menu-item--dish" key={index}>
            <div className="c-menu-item--dish-main">
              { dish.id ? <p className="c-menu-item--dish__id">{dish.id}. </p> : <p className="c-menu-item--dish__id"></p> }
              <p className="c-menu-item--dish__title">{dish.title} <span className="c-menu-item--dish__title-emojis">{ dish.isNutty ? <span>&#x1F95C;</span> : null } { dish.isVeggie ? <span>&#x1F952;</span> : null } { dish.spiceLevel > 0 ? renderSpice(dish.spiceLevel) : null }</span></p>
              <p className="c-menu-item--dish__price">£{dish.priceGbp.toFixed(2)}</p>
              { index === array.length - 1 ? null : <hr className="c-menu-item--dish__seperator" /> }
            </div>
          </div>
        );
      } else if (!dish.options && !dish.priceGbp) {
        return (
          <div className="c-menu-item--dish" key={index}>
            <div className="c-menu-item--dish-main">
              { dish.id ? <p className="c-menu-item--dish__id">{dish.id}. </p> : <p className="c-menu-item--dish__id"></p> }
              <p className="c-menu-item--dish__title">{dish.title} <span className="c-menu-item--dish__title-emojis">{ dish.isNutty ? <span>&#x1F95C;</span> : null } { dish.isVeggie ? <span>&#x1F952;</span> : null } { dish.spiceLevel > 0 ? renderSpice(dish.spiceLevel) : null }</span></p>
              { index === array.length - 1 ? null : <hr className="c-menu-item--dish__seperator" /> }
            </div>
          </div>
        );
      } else {
        return (
          <div className="c-menu-item--dish" key={index}>
            <div className="c-menu-item--dish-main">
              { dish.id ? <p className="c-menu-item--dish__id">{dish.id}. </p> : <p className="c-menu-item--dish__id"></p> }
              <p className="c-menu-item--dish__title">{dish.title} <span className="c-menu-item--dish__title-emojis">{ dish.isNutty ? <span>&#x1F95C;</span> : null } { dish.isVeggie ? <span>&#x1F952;</span> : null } { dish.spiceLevel > 0 ? renderSpice(dish.spiceLevel) : null }</span></p>
            </div>
            { 
              dish.options.map((option, index, array) => {
                return (
                  <div className="c-menu-item--dish__option" key={index}>
                    <p className="c-menu-item--dish__option-title"> - {option.title} <span className="c-menu-item--dish__option-title--emojis">{ option.isNutty ? <span>&#x1F95C;</span> : null } { option.isVeggie ? <span>&#x1F952;</span> : null } { option.spiceLevel > 0 ? renderSpice(option.spiceLevel) : null }</span></p>
                    <p className="c-menu-item--dish__option-price">£{option.priceGbp.toFixed(2)}</p>
                    { index === array.length - 1 ? null : <hr className="c-menu-item--dish__option-seperator" /> }
                  </div>
                );
              })
            }
            { index === array.length - 1 ? null : <hr className="c-menu-item--dish__seperator" /> }
          </div>
        );
      }
    });
  }

  const renderDescription = () => {
    return (
      <div className="c-menu-item--description">
        <p>{props.description}</p>
        <hr className="c-menu-item--description__seperator" />
      </div>
    );
  }

  const [open, setOpen] = useState(false);

  const classname = `c-menu-item${ !open ? '--hidden' : ''}`;

  return (
    <div className={classname}>
      <div className="c-menu-item--content">
        <div className="c-menu-item--title" onClick={() => { setOpen(!open) }}>
          <p>{props.title}</p>
          <p className="c-menu-item--title__arrow"><i className="material-icons">{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i></p>
        </div>
        <div className="c-menu-item--main">
          {props.description ? renderDescription() : null}
          {props.dishes ? renderItems() : null}
        </div>
      </div>
    </div>
  );
}

export default MenuItem;
